import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Editor } from 'primereact/editor'
import { useParams } from 'react-router-dom'
import { HrmFormInput } from '../components/hrm_input'
import { uploadImageNewsToS3, uploadImageToS3 } from '../../utils/fileUpload'
import HrmLoader from '../components/hrm_loader'
import { useNews } from '../../contexts'
import { uploadImageViaApi, vars } from '../../common/CommonFunction'
import { toast } from 'react-toastify'

const EditNews = () => {
  const { news_id } = useParams()
  const { getNews, onUpdateNews, newsLoader, newsDetail } = useNews()

  const {
    handleSubmit,
    register,
    setValue,
    watch,
    formState: { errors }
  } = useForm()

  const imageFile = watch('image')
  const logoFile = watch('logo')

  const [imagePreview, setImagePreview] = useState(null)
  const [logoPreview, setLogoPreview] = useState(null)
  const [editorText, setEditorText] = useState('')

  useEffect(() => {
    getNews(news_id)
  }, [news_id, getNews])

  useEffect(() => {
    if (newsDetail) {
      setValue('title', newsDetail.title)
      setValue('description', newsDetail.description)
      setValue('image', newsDetail.image)
      setValue('logo', newsDetail.logo)
      setValue('short_description', newsDetail.short_description)
      setEditorText(newsDetail.description || '')
      setImagePreview(newsDetail.image)
      setLogoPreview(newsDetail.logo)
    }
  }, [newsDetail, setValue])

  useEffect(() => {
    setValue('description', editorText)
  }, [editorText, setValue])

  const handleImageChange = e => {
    const file = e.target.files?.[0]
    if (file instanceof Blob) {
      const reader = new FileReader()
      reader.onloadend = () => setImagePreview(reader.result)
      reader.readAsDataURL(file)
    }
  }

  const handleLogoChange = e => {
    const file = e.target.files?.[0]
    if (file instanceof Blob) {
      const reader = new FileReader()
      reader.onloadend = () => setLogoPreview(reader.result)
      reader.readAsDataURL(file)
    }
  }

  // useEffect(() => {
  //   const file = imageFile?.[0]
  //   if (file instanceof Blob) {
  //     const reader = new FileReader()
  //     reader.onloadend = () => setImagePreview(reader.result)
  //     reader.readAsDataURL(file)
  //   }
  // }, [imageFile])

  // useEffect(() => {
  //   const file = logoFile?.[0]
  //   if (file instanceof Blob) {
  //     const reader = new FileReader()
  //     reader.onloadend = () => setLogoPreview(reader.result)
  //     reader.readAsDataURL(file)
  //   }
  // }, [logoFile])

  const extractFilename = url => (url ? url.split('/').pop() : null)

  const onSubmit = async values => {

    const payload = {
      news_id: news_id,
      title: values.title,
      description: editorText,
      short_description: values.short_description
    }

    // if (values.logo?.[0] instanceof File) {
    //   const s3Logo = await uploadImageNewsToS3(values.logo[0])
    //   payload.logo = s3Logo
    // } else {
    //   payload.logo = extractFilename(newsDetail?.logo)
    // }

    // // Upload new image or use existing filename
    // if (values.image?.[0] instanceof File) {
    //   const s3Image = await uploadImageNewsToS3(values.image[0])
    //   payload.image = s3Image
    // } else {
    //   payload.image = extractFilename(newsDetail?.image)
    // }

    if (values.logo?.[0] instanceof File) {
      const responseLogo = await uploadImageViaApi(values.logo[0], vars.folder3);

      if (responseLogo?.code === 1) {
        payload.logo = responseLogo.data.file_name;
      } else {
        toast.error(responseLogo?.message || 'Logo upload failed');
        return;
      }
    } else {
      payload.logo = extractFilename(newsDetail?.logo);
    }

    // Handle image upload or fallback
    if (values.image?.[0] instanceof File) {
      const responseImage = await uploadImageViaApi(values.image[0], vars.folder3);

      if (responseImage?.code === 1) {
        payload.image = responseImage.data.file_name;
      } else {
        toast.error(responseImage?.message || 'Image upload failed');
        return;
      }
    } else {
      payload.image = extractFilename(newsDetail?.image);
    }

    await onUpdateNews(payload)
  }

  if (newsLoader) return <HrmLoader />

  return (
    <div className='space-y-4 p-6 bg-white'>
      <h5 className='text-xl font-semibold text-gray-800'>Edit News</h5>
      <form onSubmit={handleSubmit(onSubmit)} className='space-y-4'>
        <HrmFormInput
          label='Title'
          error={errors?.title?.message}
          {...register('title')}
        />

        <HrmFormInput
          label={'Short Description'}
          placeholder={'Enter Short Description'}
          error={errors?.short_description?.message}
          {...register('short_description')}
        />

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-1'>
            Description
          </label>
          <Editor
            value={editorText}
            onTextChange={e => setEditorText(e.htmlValue)}
            style={{ height: '320px' }}
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-1'>
            Image (size 714 x 291)
          </label>
          {imagePreview && (
            <img
              src={imagePreview}
              alt='Image Preview'
              className='w-32 h-20 object-cover rounded mb-2'
            />
          )}
          <input
            type='file'
            accept='image/*'
            {...register('image')}
            className='form-control'
            onChange={e => {
              handleImageChange(e)
            }}
          />
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-1'>
            Logo (size 100 x 67)
          </label>
          {logoPreview && (
            <img
              src={logoPreview}
              alt='Logo Preview'
              className='w-32 h-20 object-cover rounded mb-2'
            />
          )}
          <input
            type='file'
            accept='image/*'
            {...register('logo')}
            className='form-control'
            onChange={e => {
              handleLogoChange(e)
            }}
          />
        </div>

        <button
          type='submit'
          className='text-white btn bg-custom-500 border-custom-500 hover:bg-custom-600'
        >
          Update News
        </button>
      </form>
    </div>
  )
}

export default EditNews
